import { configureStore } from '@reduxjs/toolkit';
import advancedSearchReducer from '../features/advancedSearch/advancedSearchSlice'

export const store = configureStore({
  reducer: {
    advancedSearch: advancedSearchReducer
  },
});
